export const JwtTokenKey = "JwtToken";
export const UserRoleKey = "UserRole";
export const AutosaveDuration = 60*1000;

export const MediaBreakpoint = {
    // https://getbootstrap.com/docs/4.0/layout/overview/#responsive-breakpoints
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,

    // https://tailwindcss.com/docs/responsive-design/
    // sm: 640,
    // md: 768,
    // lg: 1024,
    // xl: 1280,
};

export const SetSeenDuration = 3*1000;
